import { render, staticRenderFns } from "./CardGenre.vue?vue&type=template&id=2485accb&scoped=true&"
import script from "./CardGenre.vue?vue&type=script&lang=js&"
export * from "./CardGenre.vue?vue&type=script&lang=js&"
import style0 from "./CardGenre.vue?vue&type=style&index=0&id=2485accb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2485accb",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
